<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { formatMoney } from '@cwd/Shared/utils/formatMoney';
    import { SmsTopUpCreditStatus, getSmsTopUpInvoiceCredit } from './AccountPrePaidBalance.access';

    // The company's credit for "Lägg på faktura", for the account's administrators (decided 2026-10-28): limit, used, left, excl.
    // VAT, and why a top-up on invoice would be refused now. Shows nothing when it cannot be read — the purchase still checks.
    const status = ref<SmsTopUpCreditStatus | null>(null);

    onMounted(async () => {
        try {
            status.value = await getSmsTopUpInvoiceCredit();
        } catch {
            status.value = null;
        }
    });

    const money = (value: number | null): string => formatMoney(value, status.value?.CurrencyCode ?? null, 2);

    function summary(s: SmsTopUpCreditStatus): string {
        return ($Resources.SmsTopUpInvoiceCreditSummary ?? '')
            .replace('{0}', money(s.Limit))
            .replace('{1}', money(s.Used))
            .replace('{2}', money(s.Available));
    }

    function blockedMessage(s: SmsTopUpCreditStatus): string | null {
        switch (s.Blocked) {
            case 'OverdueInvoice':
                return $Resources.SmsTopUpOverdueInvoiceMessage ?? '';
            case 'AboveInvoiceLimit':
                return $Resources.SmsTopUpAboveInvoiceLimitMessage ?? '';
            case 'InvoiceDetailsMissing':
                return $Resources.SmsTopUpInvoiceDetailsMissingMessage ?? '';
            default:
                return null;
        }
    }
</script>

<template>
    <template v-if="status && status.Limit != null">
        <p class="c-light m-sm-t">{{ summary(status) }}</p>
        <p v-if="blockedMessage(status)" class="text-danger">{{ blockedMessage(status) }}</p>
    </template>
</template>
